import { Component, EventEmitter, Input, OnDestroy, Output, TemplateRef, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AdminTableSortDirection, Comparator, SortEvent } from '../models/admin-table.model';
import { AdminTableColumnService } from './admin-table-column.service';

@Component({
  selector: 'mpro-atable-column',
  templateUrl: './admin-table-column.component.html',
  styleUrls: ['./admin-table-column.component.scss']
})
export class AdminTableColumnComponent implements OnDestroy {
  @ViewChild(TemplateRef) public columnContent: TemplateRef<any>;
  @Input() public set defaultSortable(value: boolean | undefined) {
    this._defaultSortable = value !== undefined ? value : false;
    if (this._defaultSortable) {
      this.sortColumn();
    }
  }
  @Input() public sortable: string = '';
  @Input() public direction: AdminTableSortDirection = 'asc';
  @Input() public comparator?: Comparator;
  @Output() public sort = new EventEmitter<SortEvent>();

  private ngUnsubscribe: Subject<void> = new Subject();

  public get defaultSortable(): boolean {
    return this._defaultSortable;
  }
  private _defaultSortable: boolean = false;

  constructor(public columnService: AdminTableColumnService) {
    this.columnService.sortObs
      .pipe(
        takeUntil(this.ngUnsubscribe),
        filter(sortEvent => sortEvent.column === this.sortable)
      )
      .subscribe(columnToSort => this.sort.emit(columnToSort));
  }

  public sortColumn() {
    this.columnService.sort({ column: this.sortable, direction: this.direction, comparator: this.comparator ? () => <Comparator>this.comparator : undefined });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}